import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  message?: string;
}

export const SuccessMessage = ({ message }: Props) =>
  message && (
    <div className="py-1 px-6 my-4 bg-success-lighten text-success fs-3" key={message}>
      <FontAwesomeIcon className="mr-3" icon={faCheckCircle} />
      {message}
    </div>
  );
